<template>
    <card>
        <h4 slot="header" class="card-title">API Token</h4>
        <div class="row">
            <div class="col-md-12">
                <p>Your eMenu requires an API Bearer Token to receive updates from the POS system.
A Bearer Token is a secure access key that verifies your identity when making an API request.</p>
            </div>
            <div class="col-md-12 text-center">
                <button class="btn btn-outline-primary" @click="copyToken">
                   Click To Copy Bearer Token
                </button>

            </div>
        </div>
    </card>
</template>
<script>
export default {
    methods: {
        async copyToken() {
            const token = localStorage.getItem('token');

            if (!token) {
                this.$toast.error('Bearer token not found', {
                    timeout: 2000
                });
                return;
            }

            try {
                await navigator.clipboard.writeText(`${token}`);

                /* this.$toast.success('Bearer token copied', {
                    timeout: 2000
                }); */
                this.$notifications.notify({
                    message: 'API Bearer token copied',
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'right',
                    verticalAlign: 'top',
                    type: 'success'
                });
            } catch (e) {
                this.fallbackCopy(token);
            }
        },

        fallbackCopy(token) {
            const textarea = document.createElement('textarea');
            textarea.value = `${token}`;
            textarea.setAttribute('readonly', '');
            textarea.style.position = 'absolute';
            textarea.style.left = '-9999px';

            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand('copy');
            document.body.removeChild(textarea);

            /* this.$toast.success('Bearer token copied', {
                timeout: 2000
            }); */
            this.$notifications.notify({
                message: 'API Bearer token copied',
                icon: 'nc-icon nc-check-2',
                horizontalAlign: 'right',
                verticalAlign: 'top',
                type: 'success'
            });
        }
    }
};


</script>